import {ApolloClient} from 'apollo-client';
import {HttpLink} from 'apollo-link-http';
import {InMemoryCache} from 'apollo-cache-inmemory';
import Vue from 'vue';
import VueApollo from 'vue-apollo';


const {VUE_APP_GRAPHCMS_API_KEY} = process.env;

const apolloClient = new ApolloClient({
  link: new HttpLink({uri: VUE_APP_GRAPHCMS_API_KEY}),
  cache: new InMemoryCache(),
});

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

export {apolloProvider};
